import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export function UnderConstruction() {
    return (
        <Box
            width="fill-available"
            height="100%"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                m: '0 20px 0 20px',
            }}
        >
            <SmartToyRoundedIcon sx={{ fontSize: '350px' }} />
            <Typography
                color="#707070"
                variant="h1"
                fontSize="30px"
                fontWeight="700"
                textAlign={'center'}
            >
                Beep boop, we are working hard to make this tool mobile friendly
                for you!
            </Typography>
            <Typography
                color="#707070"
                variant="h2"
                fontSize="30px"
                textAlign={'center'}
            >
                Please use your desktop for now. Thank you!
            </Typography>
        </Box>
    );
}
